import { WithStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import i18n from '../resources/i18n';

import Progress from '../components/Progress';
import { IRootState } from '../reducers';
import { Routes, Screens } from '../utils/Routes';

const styles = (theme: Theme) =>
	createStyles({
		logo: {
			color: '#ddd',
			fontFamily: '"Arial Black", Helvetica-bold',
			fontSize: '20px',
			fontStyle: 'italic',
			fontWeight: 'normal',
			marginRight: 20,
			width: 'auto',
		},
		logoLink: {
			textDecoration: 'none',
		},
		root: {
			flexGrow: 1,
		},
		title: {
			flex: 1,
			[theme.breakpoints.down('sm')]: {
				fontSize: '1rem',
			},
		},
	});

interface IState {
	isShowMenuNotice?: boolean;
	isShowMenuLogout?: boolean;
	isShowConfirmLogout?: boolean;
}

/**
 * ナビゲーションバー
 */
export class NavbarComponent extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		// #8289: SCORMコンテンツから戻ってきた場合にリクエストキューを全て出力
		if (window.API) {
			window.API.flush();
		}
	}

	public render() {
		const { classes, isShowProgress } = this.props;

		return (
			<AppBar position="static">
				<Progress open={isShowProgress ? true : false} />
				<Toolbar>
					<Typography className={classes.logoLink}>
						<Hidden smDown={true}>
							<Typography variant="h6" className={classes.logo}>
								{i18n.t('Navbar_0001')}
							</Typography>
						</Hidden>
					</Typography>
					<Typography
						variant="h6"
						color="inherit"
						noWrap={true}
						className={classes.title}
					>
						{this.props.title}
					</Typography>
				</Toolbar>
			</AppBar>
		);
	}
}

export const mapStateToProps = (state: IRootState) => ({
	...state.navbar,
	isShowProgress: state.navbar.isShowProgress,
	token: state.session.token,
	tsqWindow: state.mainMenu.tsqWindow,
	userAttr: state.session.userAttr,
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
	pushHistory: (screen: Screens) => dispatch(push(Routes.getPath(screen))),
});

export interface INavbarProps {
	title: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & INavbarProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(NavbarComponent);

const NavbarPortal = withStyles(styles)(Connected);
NavbarPortal.displayName = 'Navbar';

export default NavbarPortal;



// WEBPACK FOOTER //
// ./src/containers/NavbarPortal.tsx